import React, { useEffect, useState } from 'react';
import { Flexbox, FlexboxColumn } from '../../../components/action/Flexbox';
import TwitterButton from '../../../components/action/TwitterButton';
import SpinWheel from '../../../components/SpinWheel/SpinWheel';
import ThemedText from '../../../components/theme/ThemedText';
import ThemeLogo from '../../../components/theme/ThemeLogo';
import { useBackendApi } from '../../../helpers/backendHelper';
import { trackClairtyEvent } from '../../../utils';

const Invite = () => {
  const backendHelper = useBackendApi();
  const [userCodes, setCodes] = useState();

  const copyToClipboard = item => {
    if (item?.used) return;

    navigator.clipboard
      .writeText(item?.code)
      .then(() => {
        alert.info('Code copied');
        trackClairtyEvent('copiedinvite', item?.code);
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
      });
  };

  async function getUserCodes() {
    try {
      const response = await backendHelper.reviews.getUserCodes();
      setCodes(response.data);
    } catch (error) {
      setCodes([]);
    }
  }

  async function openTweetIntent() {
    const tweetText = encodeURIComponent(`I am the lucky one who won invite codes of @0xmercle’s OnionTake system. Now tell me why should i give it to you in comments!`);

    const tweetUrl = `https://twitter.com/intent/tweet?text=${tweetText}`;
    window.open(tweetUrl, '_blank');
  }
  function handleSpin(win) {
    if (win) {
      getUserCodes();
    }
  }

  useEffect(() => {
    getUserCodes();
  }, []);
  console.log({ userCodes });
  if (userCodes === undefined)
    return (
      <FlexboxColumn className='feed_wrapper invite_overflow'>
        <span className='invite_wrapper_loader'></span>
      </FlexboxColumn>
    );

  if (userCodes && userCodes.length === 0) return <SpinWheel onResult={handleSpin} />;

  return (
    <FlexboxColumn className='feed_wrapper invite_overflow' justiftContent='flex-start' gap='6rem'>
      <FlexboxColumn gap='0.5rem'>
        <ThemedText.H2 weight='medium'>
          invite people to make <ThemedText.Span weight='semi-bold'>OnionTakes</ThemedText.Span> better.
        </ThemedText.H2>
        <ThemedText.H5 color='color-xlight'>Congrats! You’ve won 5 invite codes, use them wisely.</ThemedText.H5>
      </FlexboxColumn>

      <FlexboxColumn>
        <ThemedText.H5>Your active codes</ThemedText.H5>
        <Flexbox className='feed_wrapper_invite_codes'>
          {userCodes &&
            userCodes.map(item => (
              <div className={`feed_wrapper_invite_chip ${item?.used ? 'feed_wrapper_invite_disabled' : ''}`} onClick={() => copyToClipboard(item)}>
                <ThemedText.H4>{item?.code}</ThemedText.H4>
              </div>
            ))}
        </Flexbox>

        <TwitterButton onClick={openTweetIntent}>
          <ThemeLogo icon={'twitterLogo'} />
          <ThemedText.H5>Share to the world</ThemedText.H5>
        </TwitterButton>
      </FlexboxColumn>
    </FlexboxColumn>
  );
};

export default Invite;
